import React from "react";

export interface SegmentedControlProps {
  options: { value: string | number; label: string; icon?: React.ReactNode; disabled?: boolean; }[];
  value: string | number;
  onChange: (value: string | number) => void;
  className?: string;
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  orientation?: "horizontal" | "vertical";
  label?: string;
  theme?: "light" | "dark";
    /**
   * Clase Tailwind opcional para establecer un max-width.
   * @default "max-w-[504px]"
   */
  maxWidthClass?: string;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  value,
  onChange,
  className = "",
  disabled = false,
  orientation = "horizontal",
  maxWidthClass = "max-w-[180px]",
  label,
}) => {
    const totalOptions = options.length;
    const buttonWidth = `w-[${100 / totalOptions}%]`;
  return (
    <div className={`flex flex-col ${className} ${maxWidthClass}`}>
      {/* Label (if provided) */}
      {label && <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>}

      {/* Segmented Control */}
      <div
        className={`flex ${
          orientation === "vertical" ? "flex-col w-full" : "flex-row w-full"
        } h-12 rounded-md border border-gray-300 bg-gray-100 overflow-hidden`}
      >
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => (!disabled && !option.disabled) && onChange(option.value)}
            className={`flex-1 px-1 py-2 flex items-center justify-center text-sm ${buttonWidth} ${
              value === option.value
                ? "bg-white text-black font-semibold rounded-md border border-gray-300"
                : "text-gray-500 hover:bg-gray-200"
            } ${
              (disabled || option.disabled) ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={disabled || option.disabled} // ✅ Disabling button if needed
          >
            {option.icon && <span className="mr-2">{option.icon}</span>}
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SegmentedControl;
